function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h26v26H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.007 12.856c4.165 1.51 2.89 2.107-.326 3.44-.014-.026.006.177 0 1.83-.005 1.048-3.317 1.048-3.32 0v-1.83h-3.257l.015 1.83c-.052 1.047-3.363 1.05-3.352 0v-1.83c-2.829-.227-4.557-1.16-5.457-3.507a95.28 95.28 0 01-1.77 0c-.945.126-1.425-.617-1.44-2.23-.016-1.612.364-2.5 1.141-2.665h1.555c.788-2.561 1.98-4.163 4.704-4.892.008-.586-.013-2.668 0-2.978 2.212-.054 3.068 1.11 3.068 2.978.046.028.137.036.131.082-.2 1.623-.527.426-.396 3.47.048 1.103.89 2.267 2.44 3.402 1.549 1.134 2.1 1.391 6.264 2.9zM6.075 9.02c.569 0 1.03-.483 1.03-1.08 0-.596-.461-1.079-1.03-1.079s-1.03.483-1.03 1.08c0 .596.461 1.08 1.03 1.08z",
  fill: "#43A047"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 9c.01 2.288.034 1.628 0 2-.21 2.297-1.104 3.963-4.32 5.295-.013-.025.007.178 0 1.83-.004 1.049-3.316 1.049-3.319 0v-1.83h-3.257l.015 1.83c-.052 1.048-3.363 1.05-3.352 0v-1.83c-2.829-.226-4.557-1.16-5.457-3.506a95.28 95.28 0 01-1.77 0c-.945.126-1.425-.617-1.44-2.23-.016-1.612.364-2.5 1.141-2.665h1.555c.788-2.561 1.98-4.163 4.704-4.892.008-.586-.013-2.668 0-2.978 2.212-.054 3.068 1.11 3.068 2.978 4.903.009 2.07-.023 5.829 0 1.977.011 3.63.714 4.798 1.966C22.39 6.13 22.993 7.474 23 9z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#371447",
  cx: 6.316,
  cy: 7.917,
  rx: 1.263,
  ry: 1.319
})));

function SvgMakeYourOwnSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMakeYourOwnSm;